import React from "react";
import { FaList } from "react-icons/fa";
import { FiFilter, FiGrid } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { openFilterMenu } from "../../../../features/uiSlice";
import {useFilterContext} from "../../../../context/filter_context";
import {FILTER_SELLERS} from "../../../../actions";

const HeadeFilters = ({ layout, setLayout }) => {
  const { setListView, grid_view,setGridView,updateFilters } = useFilterContext();
  const dispatch = useDispatch();
  return (
    <div className="flex-col gap-4 flex-center-between md:flex-row">
      <div className="w-full flex-center-between">
        <div className="gap-2 flex-align-center">
          <div
            className={`w-10 h-10 rounded-xl grid place-items-center bg-slate-100 hover:bg-slate-200 sm:cursor-pointer transition-a dark:bg-card-dark  ${
                grid_view === "grid" && "!bg-primary text-white"
            }`}
            onClick={() => setGridView()}
          >
            <FiGrid />
          </div>
          <div
            className={`w-10 h-10 rounded-xl grid place-items-center bg-slate-100 sm:cursor-pointer hover:bg-slate-200 transition-a dark:bg-card-dark ${
                grid_view === "list" && "!bg-primary text-white"
            }`}
            onClick={() => setListView()}
          >
            <FaList />
          </div>
          <div
            className="grid w-10 h-10 md:hidden rounded-xl place-items-center bg-slate-100 sm:cursor-pointer hover:bg-slate-200 transition-a dark:bg-card-dark"
            onClick={() => dispatch(openFilterMenu())}
          >
            <FiFilter />
          </div>
        </div>
        {/*<p>Showing 01 - 08 of 28 resuts</p>*/}
      </div>
      <div className="w-full gap-4 flex-center-between">
        <select
          name="sortby"
          id=""
          className="w-full px-3 py-2 bg-white border outline-none dark:border-dark dark:bg-main-dark"
        >
          <option value="">Sort by</option>
          <option value="relavence">Relevance</option>
          <option value="rating">Rating</option>
          <option value="distance">Distance</option>
        </select>
        <input
          type="text"
          className="border outline-none bg-transparent dark:border-dark px-3 py-[0.35rem] w-full"
          placeholder="Enter Keywords.."
          onChange={(event)=> {
            updateFilters(event.target.value,"text");
            dispatch({ type: FILTER_SELLERS });
          }}
        />
      </div>
    </div>
  );
};

export default HeadeFilters;
